<template>
  <div class="bg-sidebar py-4 px-4 d-none d-sm-block h-100">
    <div class="border-image text-center">
      <img
        src="@/assets/logo/logo-2.png"
        alt="logo-2"
        class="pb-4"
      >
    </div>
    <ul class="pt-5">
      <li
        v-for="(item, i) of menus"
        :key="i"
      >
        <router-link
          v-if="item.link && permissions.includes(item.permission)"
          :to="item.link"
        >
          <div class="d-flex align-items-center m-0 py-2 mb-2">
            <span class="px-md-3 px-lg-3">
              <i
                class="fa fa-fw"
                :class="item.icon"
                aria-hidden="true"
              />
            </span>
            <small class="font-weight-bold sidebar-text text-truncate">
              {{ item.name }}
            </small>
          </div>
        </router-link>

        <div
          v-if="item.children && showParent(item)"
          @click="expand(i)"
        >
          <div class="d-flex align-items-center m-0 py-2 mb-2">
            <span class="px-md-3 px-lg-3">
              <i
                class="fa fa-fw"
                :class="item.icon"
                aria-hidden="true"
              />
            </span>
            <small class="font-weight-bold sidebar-text text-truncate">
              {{ item.name }}
            </small>
            <i
              class="fa ml-auto"
              :class="{
                'fa-angle-up': item.expanded,
                'fa-angle-down': !item.expanded
              }"
            />
          </div>

          <div v-if="item.expanded">
            <span
              v-for="(child, c) of item.children"
              :key="c"
            >
              <router-link
                v-if="permissions.includes(child.permission)"
                :to="child.link"
                tag="div"
                class="pl-5 py-2"
              >
                <small>
                  <small class="font-weight-bold pl-1">
                    {{ child.name }}
                  </small>
                </small>
              </router-link>
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menus: [
        {
          link: 'dashboard',
          name: 'Dashboard',
          icon: 'fa-pie-chart',
          permission: 'dashboard'
        },
        {
          link: 'my-assessment',
          name: 'My DHM',
          icon: 'fa-file-text-o',
          permission: 'my_dhm'
        },
        {
          link: 'all-assessment',
          name: 'All DHM',
          icon: 'fa-files-o',
          permission: 'all_dhm'
        },
        {
          link: 'user-management',
          name: 'User Management',
          icon: 'fa-user',
          permission: 'user'
        },
        {
          name: 'Settings',
          icon: 'fa-cog',
          expanded: true,
          children: [
            {
              link: 'manage-security-group',
              name: 'Manage Security Group',
              permission: 'role'
            },
            {
              link: 'manage-master-data',
              name: 'Manage Master Data',
              permission: 'master_data'
            },
            {
              link: 'manage-notification',
              name: 'Manage Notification',
              permission: 'notification'
            },
            {
              link: 'manage-question',
              name: 'Manage Question',
              permission: 'question'
            }
          ]
        }
      ],
      permissions: []
    }
  },

  mounted () {
    const dataLoc = JSON.parse(localStorage.getItem('profile'))
    this.permissions = dataLoc.role.permissions
      .filter(permission => permission.permissions.includes('browse'))
      .map(({ category }) => category)
  },

  methods: {
    expand (index) {
      this.menus[index].expanded = !this.menus[index].expanded
    },
    showParent (item) {
      return item.children.some(child => this.permissions.includes(child.permission))
    }
  }
}
</script>

<style scoped>
.bg-sidebar,
.bg-sidebar-2 {
  border-radius: 12px;
  background-color: #ffffff;
}
.bg-sidebar {
  min-height: 93vh;
}
.bg-sidebar-2 {
  height: 75px;
}
.border-image {
  border-bottom: 2px solid #dedede;
}
ul li {
  list-style: none;
  text-decoration: none;
  cursor: pointer;
}
ul li a {
  display: block;
}
a {
  text-decoration: none;
  color: black;
}
.router-link-active {
  background-color: #18b2bd;
  color: white !important;
  border-radius: 4px;
  cursor: pointer;
}
.sidebar-expand {
  background-color: #ffffff;
  min-width: 85vw;
  border-radius: 12px;
  border: 1px solid #dedede;
}
</style>
